'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cn = require('../utils/cn');

var _cn2 = _interopRequireDefault(_cn);

var _prism = require('../utils/prism');

var _prism2 = _interopRequireDefault(_prism);

var _normalizeCode = require('../utils/normalizeCode');

var _normalizeCode2 = _interopRequireDefault(_normalizeCode);

var _normalizeHtml = require('../utils/normalizeHtml');

var _normalizeHtml2 = _interopRequireDefault(_normalizeHtml);

var _htmlToPlain = require('../utils/htmlToPlain');

var _htmlToPlain2 = _interopRequireDefault(_htmlToPlain);

var _escapeHtml = require('../utils/escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

var _selectionRange6 = require('../vendor/selection-range');

var _selectionRange7 = _interopRequireDefault(_selectionRange6);

var _getIndent = require('../utils/getIndent');

var _contentEditableUtils = require('../utils/contentEditableUtils');

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function disableHtml(html, _ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;

    return html;
}

var Editor = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Editor, _Component);

    function Editor() {
        var _ref2,
            _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Editor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Editor.__proto__ || (0, _getPrototypeOf2.default)(Editor)).call.apply(_ref2, [this].concat(args))), _this), _this.id = Math.random() + '-' + new Date().getTime(), _this.undoStack = [], _this.undoOffset = 0, _this.undoTimestamp = 0, _this.compositing = false, _this.state = {
            html: '',
            prefixHtml: ''
        }, _this.onRef = function (node) {
            _this.ref = node;
        }, _this.getPlain = function () {
            if (_this._innerHTML === _this.ref.innerHTML) {
                return _this._plain;
            }

            var plain = (0, _htmlToPlain2.default)((0, _normalizeHtml2.default)(_this.ref.innerHTML));

            _this._plain = plain;
            _this._innerHTML = _this.ref.innerHTML;

            return _this._plain;
        }, _this.recordChange = function (plain, selection) {
            if (plain === _this.undoStack[_this.undoStack.length - 1]) {
                return;
            }

            // if (this.undoOffset > 0) {
            //     this.undoStack = this.undoStack.slice(0, -this.undoOffset)
            //     this.undoOffset = 0
            // }

            var timestamp = Date.now();
            var record = { plain: plain, selection: selection

                // Overwrite last record if threshold is not crossed
            };if (timestamp - _this.undoTimestamp < 3000) {
                _this.undoStack[_this.undoStack.length - 1] = record;
            } else {
                _this.undoStack.push(record);

                if (_this.undoStack.length > 50) {
                    _this.undoStack.shift();
                }
            }

            _this.undoTimestamp = timestamp;
        }, _this.updateContent = function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var plain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.getPlain();
                var callback = arguments[1];
                var highlighted;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _prism2.default)({ id: _this.id, code: plain, language: _this.props.language, workerUrl: _this.props.workerUrl });

                            case 2:
                                highlighted = _context.sent;

                                _this.setState({ html: highlighted }, callback);

                                if (_this.props.onChange) {
                                    _this.props.onChange(plain);
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function () {
                return _ref3.apply(this, arguments);
            };
        }(), _this.restoreStackState = function (offset) {
            var _this$undoStack = _this.undoStack[_this.undoStack.length - 1 - offset],
                plain = _this$undoStack.plain,
                selection = _this$undoStack.selection;


            _this.selection = selection;
            _this.undoOffset = offset;
            _this.updateContent(plain);
        }, _this.undo = function () {
            var offset = _this.undoOffset + 1;
            if (offset >= _this.undoStack.length) {
                return;
            }

            _this.restoreStackState(offset);
        }, _this.redo = function () {
            var offset = _this.undoOffset - 1;
            if (offset < 0) {
                return;
            }

            _this.restoreStackState(offset);
        }, _this.onKeyDown = function (evt) {
            var _this$props = _this.props,
                onKeyDown = _this$props.onKeyDown,
                tabSize = _this$props.tabSize;


            if (onKeyDown) {
                onKeyDown(evt);
            }

            if (_this.props.ignoreTabKey && evt.keyCode === 9) {
                return;
            }

            var shiftTab = false;
            if (evt.keyCode === 9 && !evt.shiftKey) {
                // Tab Key
                document.execCommand('insertText', false, ' '.repeat(tabSize));
                evt.preventDefault();
            } else if (evt.keyCode === 8 || (shiftTab = evt.keyCode === 9 && evt.shiftKey)) {
                // Backspace Key / Shift Tab
                var _selectionRange = (0, _selectionRange7.default)(_this.ref),
                    cursorPos = _selectionRange.start,
                    cursorEndPos = _selectionRange.end;

                if (cursorPos !== cursorEndPos) {
                    return; // Bail on selections
                }

                var deindent = (0, _getIndent.getDeindentLevel)(_this.getPlain(), cursorPos, tabSize);
                if (deindent <= 0) {
                    shiftTab && evt.preventDefault();
                    return; // Bail when deindent level defaults to 0
                }

                // Delete chars `deindent` times
                (0, _contentEditableUtils.deleteTimes)(deindent);

                evt.preventDefault();
            } else if (evt.keyCode === 13) {
                // Enter Key
                var _selectionRange2 = (0, _selectionRange7.default)(_this.ref),
                    _cursorPos = _selectionRange2.start;

                var indentation = (0, _getIndent.getIndent)(_this.getPlain(), _cursorPos);
                document.execCommand('insertHTML', false, '\n' + indentation);
                evt.preventDefault();
                // this.undoTimestamp = 0
            } else if (
            // Undo / Redo
            evt.keyCode === 90 && evt.metaKey !== evt.ctrlKey && !evt.altKey) {
                if (evt.shiftKey) {
                    _this.redo();
                } else {
                    _this.undo();
                }

                evt.preventDefault();
            } else if (
            // Cmd/Ctrl + `/`
            evt.ctrlKey !== evt.metaKey && evt.keyCode === 191) {
                evt.preventDefault();

                var _selectionRange3 = (0, _selectionRange7.default)(_this.ref),
                    _cursorPos2 = _selectionRange3.start,
                    selectionEndPos = _selectionRange3.end;

                var plain = _this.getPlain();
                var range = (0, _getIndent.getLineRange)(plain, _cursorPos2);
                var line = (0, _getIndent.getLine)(plain, _cursorPos2);
                // Remove `//` begin of line
                if (/^(\s*)(\/\/\s?)/.test(line)) {
                    var pos = range[0] + RegExp.$1.length + RegExp.$2.length;
                    (0, _selectionRange7.default)(_this.ref, { start: pos, end: pos });
                    (0, _contentEditableUtils.deleteTimes)(RegExp.$2.length);
                    (0, _selectionRange7.default)(_this.ref, { start: _cursorPos2 - RegExp.$2.length, end: selectionEndPos - RegExp.$2.length });

                    return;
                }

                // Append `// ` begin of line
                (0, _selectionRange7.default)(_this.ref, { start: range[0], end: range[0] });
                document.execCommand('insertText', false, '// ');
                if (range[1] !== plain.length) {
                    (0, _selectionRange7.default)(_this.ref, { start: _cursorPos2 - range[0] + range[1], end: selectionEndPos - range[0] + range[1] });
                } else {
                    // EOF
                    (0, _selectionRange7.default)(_this.ref, { start: _cursorPos2 + 3, end: selectionEndPos + 3 });
                }
            } else if (
            // Cmd/Ctrl + `D`
            evt.ctrlKey !== evt.metaKey && evt.keyCode === 68) {
                evt.preventDefault();

                var _selectionRange4 = (0, _selectionRange7.default)(_this.ref),
                    _cursorPos3 = _selectionRange4.start,
                    _selectionEndPos = _selectionRange4.end;

                var _plain = _this.getPlain();
                var _line = (0, _getIndent.getLine)(_plain, _cursorPos3);
                var _range = (0, _getIndent.getLineRange)(_plain, _cursorPos3);
                if (_cursorPos3 === _selectionEndPos) {
                    (0, _selectionRange7.default)(_this.ref, { start: _range[1], end: _range[1] });
                    if (_range[1] !== _plain.length) {
                        document.execCommand('insertText', false, _line.replace(/\n$/, '\r\n'));
                    } else {
                        document.execCommand('insertText', false, '\n' + _line.replace(/\n$/, '\r\n'));
                    }

                    var _selectionRange5 = (0, _selectionRange7.default)(_this.ref),
                        start = _selectionRange5.start,
                        end = _selectionRange5.end;

                    (0, _selectionRange7.default)(_this.ref, {
                        start: _range[1] + (_cursorPos3 - _range[0]),
                        end: _range[1] + (_selectionEndPos - _range[0])
                    });
                } else {
                    (0, _selectionRange7.default)(_this.ref, {
                        start: _selectionEndPos,
                        end: _selectionEndPos
                    });
                    var selectionText = _line.substring(_cursorPos3 - _range[0], _selectionEndPos - _range[0]);
                    document.execCommand('insertText', false, selectionText);
                    (0, _selectionRange7.default)(_this.ref, {
                        start: _selectionEndPos,
                        end: _selectionEndPos + selectionText.length
                    });
                }
            }
        }, _this.onKeyUp = function (evt) {
            if (_this.props.onKeyUp) {
                _this.props.onKeyUp(evt);
            }
            // if (
            //     (
            //         evt.keyCode === 91 || // left cmd
            //         evt.keyCode === 93 || // right cmd
            //         evt.ctrlKey ||
            //         evt.metaKey
            //     ) && (evt.keyCode !== 191 || evt.keyCode !== 68)
            // ) {
            //     return;
            // }

            // Enter key
            if (evt.keyCode === 13) {
                _this.undoTimestamp = 0;
            }

            _this.selection = (0, _selectionRange7.default)(_this.ref);

            if (evt.keyCode !== 37 && // left
            evt.keyCode !== 38 && // up
            evt.keyCode !== 39 && // right
            evt.keyCode !== 40 // down
            ) {
                    var plain = _this.getPlain();

                    _this.recordChange(plain, _this.selection);
                    !_this.compositing && _this.updateContent(plain);
                } else {
                _this.undoTimestamp = 0;
            }
        }, _this.onCompositionStart = function (evt) {
            if (_this.props.onCompositionStart) {
                _this.props.onCompositionStart(evt);
            }
            _this.compositing = true;
        }, _this.onCompositionEnd = function (evt) {
            if (_this.props.onCompositionEnd) {
                _this.props.onCompositionEnd(evt);
            }
            _this.compositing = false;
        }, _this.onClick = function (evt) {
            if (_this.props.onClick) {
                _this.props.onClick(evt);
            }
            _this.undoTimestamp = 0; // Reset timestamp
            _this.selection = (0, _selectionRange7.default)(_this.ref);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Editor, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _prism.killWorker)(this.id);
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var html, prefixHtml;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return (0, _prism2.default)({ id: this.id, code: (0, _normalizeCode2.default)(this.props.code), language: this.props.language, workerUrl: this.props.workerUrl });

                            case 2:
                                html = _context2.sent;

                                this.setState({ html: html });
                                this.recordChange(this.getPlain());
                                this.undoTimestamp = 0; // Reset timestamp

                                if (!this.props.prefixCode) {
                                    _context2.next = 11;
                                    break;
                                }

                                _context2.next = 9;
                                return (0, _prism2.default)({ code: (0, _normalizeCode2.default)(this.props.prefixCode), language: this.props.language });

                            case 9:
                                prefixHtml = _context2.sent;

                                this.setState({ prefixHtml: prefixHtml });

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function componentDidMount() {
                return _ref4.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'componentWillReceiveProps',
        value: function () {
            var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref6) {
                var code = _ref6.code,
                    language = _ref6.language,
                    workerUrl = _ref6.workerUrl,
                    prefixCode = _ref6.prefixCode,
                    prefixCodeClassName = _ref6.prefixCodeClassName;
                var html, prefixHtml;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(code !== this.props.code || language !== this.props.language || workerUrl !== this.props.workerUrl)) {
                                    _context3.next = 5;
                                    break;
                                }

                                _context3.next = 3;
                                return (0, _prism2.default)({ id: this.id, code: (0, _normalizeCode2.default)(code), language: language, workerUrl: workerUrl });

                            case 3:
                                html = _context3.sent;

                                this.setState({ html: html });

                            case 5:
                                if (!(prefixCode !== this.props.prefixCode || language !== this.props.language || prefixCodeClassName !== this.props.prefixCodeClassName)) {
                                    _context3.next = 12;
                                    break;
                                }

                                prefixHtml = '';

                                if (!prefixCode) {
                                    _context3.next = 11;
                                    break;
                                }

                                _context3.next = 10;
                                return (0, _prism2.default)({ code: (0, _normalizeCode2.default)(prefixCode), language: language });

                            case 10:
                                prefixHtml = _context3.sent;

                            case 11:
                                this.setState({ prefixHtml: prefixHtml });

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function componentWillReceiveProps(_x2) {
                return _ref5.apply(this, arguments);
            }

            return componentWillReceiveProps;
        }()
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var selection = this.selection;

            if (selection) {
                (0, _selectionRange7.default)(this.ref, selection);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                contentEditable = _props.contentEditable,
                className = _props.className,
                mountStyle = _props.mountStyle,
                tabSize = _props.tabSize,
                style = _props.style,
                workerUrl = _props.workerUrl,
                prefixCode = _props.prefixCode,
                prefixCodeClassName = _props.prefixCodeClassName,
                editContentClassName = _props.editContentClassName,
                code = _props.code,
                ignoreTabKey = _props.ignoreTabKey,
                language = _props.language,
                rest = (0, _objectWithoutProperties3.default)(_props, ['contentEditable', 'className', 'mountStyle', 'tabSize', 'style', 'workerUrl', 'prefixCode', 'prefixCodeClassName', 'editContentClassName', 'code', 'ignoreTabKey', 'language']);
            var _state = this.state,
                html = _state.html,
                prefixHtml = _state.prefixHtml;

            return _react2.default.createElement(
                'pre',
                null,
                mountStyle && _react2.default.createElement(_Style2.default, null),
                _react2.default.createElement(
                    'code',
                    { className: (0, _cn2.default)('code-editor', 'hljs', className) },
                    _react2.default.createElement('div', {
                        className: (0, _cn2.default)('prefix-code', prefixCodeClassName),
                        dangerouslySetInnerHTML: { __html: prefixHtml }
                    }),
                    _react2.default.createElement('div', (0, _extends3.default)({
                        spellCheck: 'false'
                    }, rest, {
                        ref: this.onRef,
                        style: style,
                        onKeyDown: contentEditable ? this.onKeyDown : undefined,
                        onKeyUp: contentEditable ? this.onKeyUp : undefined,
                        onCompositionEnd: contentEditable ? this.onCompositionEnd : undefined,
                        onCompositionStart: contentEditable ? this.onCompositionStart : undefined,
                        onClick: contentEditable ? this.onClick : undefined,
                        contentEditable: contentEditable,
                        className: (0, _cn2.default)('edit-content', editContentClassName),
                        dangerouslySetInnerHTML: { __html: html }
                    }))
                )
            );
        }
    }]);
    return Editor;
}(_react.Component), _class.defaultProps = {
    contentEditable: true,
    mountStyle: true,
    language: '',
    tabSize: 4,
    code: '',
    prefixCode: '',
    prefixCodeClassName: '',
    editContentClassName: '',
    className: '',
    style: {},
    workerUrl: null,
    ignoreTabKey: false
}, _temp2);
exports.default = Editor;


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/~/react-code-editor/lib/Editor/index.js